import isEmpty from "../../is-Empty";
import validator from "validator";

export const RestaurantChainSettings = (data) => {
  let errors = {};

  data.name = !isEmpty(data.name) ? data.name : "";
  data.address = !isEmpty(data.address) ? data.address : "";
  data.area = !isEmpty(data.area) ? data.area : "";
  data.city = !isEmpty(data.city) ? data.city : "";
  // data.addChain = !isEmpty(data.addChain) ? data.addChain : "";
  data.phone_numbers = !isEmpty(data.phone_numbers) ? data.phone_numbers : "";
  data.enquiry_emails = !isEmpty(data.enquiry_emails)
    ? data.enquiry_emails
    : "";
  data.email = !isEmpty(data.email) ? data.email : "";
  data.phone = !isEmpty(data.phone) ? data.phone : "";

  if (validator.isEmpty(data.name)) {
    errors.name = "Rastaurant chain name is required";
  }
  if (validator.isEmpty(data.address)) {
    errors.address = "Address is required";
  }
  if (validator.isEmpty(data.area)) {
    errors.area = "Area is required";
  }
  if (validator.isEmpty(data.city)) {
    errors.city = "City is required";
  }
  // if (validator.isEmpty(data.addChain)) {
  //   errors.addChain = "Chain image is required";
  // }
  if (validator.isEmpty(data.email)) {
    errors.email = "Email is required";
  }
  if (validator.isEmpty(data.phone)) {
    errors.phone = "Phone is required";
  }
  //   if (validator.isEmpty(data.phone_numbers)) {
  //     errors.phone_numbers = "Phone number is required";
  //   }
  //   if (validator.isEmpty(data.enquiry_emails)) {
  //     errors.enquiry_emails = "Email is required";
  //   }

  return {
    errors,
    isValid: isEmpty(errors),
  };
};
